import { useState } from "react"

export type FieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string
  helperText?: string
  errorText?: string
  raised?: boolean
}

export const COLORS = {
  dark: '#0E4A2C',
  dark2: '#0B3B23',
  bg: '#F6FFFA',
  ring: 'rgba(14, 74, 44, 0.22)',
  line: 'rgba(14, 74, 44, 0.18)',
  text: '#0B2B18',
  sub: 'rgba(11, 43, 24, 0.7)',
  placeholder: 'rgba(11, 43, 24, 0.45)',
  // Brand greens
  g1: '#B8F06B',
  g2: '#67D34A',
  g3: '#35B63A',
  // Neutrals
  white: '#FFFFFF',
  danger: '#B42318',
}

export function useFocusRing() {
  const [focused, setFocused] = useState(false)
  return {
    focused,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
  }
}

export function LabelBlock({ label, helperText, errorText, children }: { label: string; helperText?: string; errorText?: string; children: React.ReactNode }) {
  return (
    <label style={{ display: 'grid', gap: 8, width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
        <span style={{ fontWeight: 900, color: COLORS.text }}>{label}</span>
        {helperText && !errorText ? <span style={{ color: COLORS.sub, fontSize: 12 }}>{helperText}</span> : null}
        {errorText ? <span style={{ color: COLORS.danger, fontSize: 12, fontWeight: 700 }}>{errorText}</span> : null}
      </div>
      {children}
    </label>
  )
}

export type CheckProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string
}